import api from '../api'

const state = {
  all: [],
  plugin: null
}

const actions = {
  getPlugins: ({ state, commit }) => {
    return api.getAllPlugins().then(plugins => {
      return commit('setAllPlugins', plugins)
    })
  },
  addPlugin: ({ state, commit }, data) => {
    return api.addSinglePlugin(data).then((response) => {
      return commit('setSinglePlugin', response.data)
    })
  }
}

const mutations = {
  setAllPlugins (state, plugins) {
    state.all = plugins
  },
  setSinglePlugin (state, plugin) {
    state.plugin = plugin
  }
}

const getters = {
  all: state => {
    return state.all
  },
  plugin: state => {
    return state.plugin
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/plugins.js